/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : dynamicTemplateReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const initialState = {
  error: false,
  msg: "",
  dynamicTemplate: [],
  totalCount: 0,
};

const dynamicTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_DYNAMIC_TEMPLATE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        dynamicTemplate: action.payload.error ? [] : action.payload.data,
        totalCount: action.payload.error ? 0 : action.payload.total_count,
      };

    case actionType.ADD_DYNAMIC_TEMPLATE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };

    case actionType.UPDATE_DYNAMIC_TEMPLATE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.UPDATE_STATUS_DYNAMIC_TEMPLATE:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };

    default:
      return state;
  }
};

export default dynamicTemplateReducer;
